import { IDynamicYieldService } from '../interfaces/dynamic-yield-service.interface';
import {dyStaticApiService, loggerService, requestService} from '@contorion/core';
import {
    IDynamicYieldRecommendationContext,
    IDynamicYieldEvent,
    IEngagement,
} from '../interfaces/dynamic-yield.interface';

class DynamicYieldService implements IDynamicYieldService {
    private dyEventPayloadQueue : Array<IDynamicYieldEvent> = [];
    public getRecommendationContext(): IDynamicYieldRecommendationContext | null {
        return window.DY.recommendationContext ?? null;
    }

    public setRecommendationContext(context: IDynamicYieldRecommendationContext): void {
        window.DY.recommendationContext = context;
    }

    public emitEvent(eventPayload: IDynamicYieldEvent): void {
        this.dyEventPayloadQueue.push(eventPayload);
        this.executeEventQueue();
    }

    public fireEngagementEvent(data: IEngagement): void {
        requestService.post('/engagement', JSON.stringify({
            engagements: [data]
        }));
    }

    public async getRecommendedSkus(
        strategyId: number
    ): Promise<Array<string>> {
        return new Promise((resolve, reject) => {
            try {
                dyStaticApiService.ready(() => {
                    window.DYO.recommendationWidgetData(strategyId, {},
                        (error: any, data: any) => {
                            if (error) {
                                loggerService.error(error, 'Dynamic yield recommendationWidgetData failed');
                                resolve([]);
                            }
                            resolve(data.slots.map((slot: any) => slot.item.sku));
                        });
                })
            } catch (e) {
                loggerService.error(e, 'Dynamic yield recommendationWidgetData failed');
                resolve([]);
            }
        });
    }

    constructor() {
        window.addEventListener('dy-static-load', () => {
            this.executeEventQueue();
        });
    }

    private executeEventQueue(): void {
        if (!window?.DY?.API || !this.dyEventPayloadQueue.length) {
            return;
        }

        while (this.dyEventPayloadQueue.length) {
            const eventPayload: IDynamicYieldEvent = this.dyEventPayloadQueue.pop();
            try {
                window.DY.API('event', eventPayload);
            } catch (e) {
                loggerService.error(e, 'Dynamic yield operation failed to fire');
            }
        }
    }
}

export const dynamicYieldService: IDynamicYieldService = new DynamicYieldService();
